import React from 'react';
import { useRouter } from 'next/navigation';
import { Popover } from '@headlessui/react';
import Button from 'components/commercetools-ui/atoms/button';
import Link from 'components/commercetools-ui/atoms/link';
import { useFormat } from 'helpers/hooks/useFormat';
import { SmartLink } from 'components/commercetools-ui/atoms/smart-link';

const LoggedOut = () => {
  const router = useRouter();
  const { formatMessage: formatAccountMessage } = useFormat({ name: 'account' });

  const goToLoginPage = () => (window.location.href = '/login');
  //  router.push('/login')
  return (
    <div className="w-[235px] p-14">
      <Popover.Button as="div" className="w-full">
        <Button variant="primary" className="w-full py-12 text-16 leading-[16px]" onClick={goToLoginPage}>
          {formatAccountMessage({ id: 'sign.in', defaultMessage: 'Sign in' })}
        </Button>
      </Popover.Button>
      <div className="mt-32 flex pb-10 ">
        <span className="whitespace-nowrap">
          {formatAccountMessage({ id: 'not.member', defaultMessage: 'Not a member' })}?
        </span>
        <Popover.Button>
          <SmartLink
            href={'/register'}
            showLoader={false}
            className="ml-4 whitespace-nowrap font-medium text-primary-black hover:underline"
          >
            {formatAccountMessage({ id: 'join.here', defaultMessage: 'Join here' })}
          </SmartLink>
        </Popover.Button>
      </div>
    </div>
  );
};

export default LoggedOut;
